import { getLocale, getProfileId } from 'lib/store';
import { apiClient } from 'services/api-client';

export const getAppNotifications = async ({
  status,
  page,
}: {
  status?: 'read' | 'unread';
  page?: number | undefined;
}) => {
  return (await apiClient.get('/app-notification', {
    params: {
      os: 'web',
      locale: getLocale(),
      profile_id: getProfileId(),
      ...(status && { status }),
      ...(page && { page_number: page.toString(), page_size: '10' }),
    },
  })) as any;
};

export async function updateNotificationStatus(data: {
  notification_id: string[];
}) {
  return await apiClient.post(
    `/app-notification?os=web&locale=${getLocale()}&profile_id=${getProfileId()}&action=mark-read`,
    data
  );
}
